export default (superclass) => class Taggable extends superclass {
    /*
     * Return a new collection with the models that match all tags sent
     * in the tags parameter, and/or it doesn't have any tags from the
     * excludeTags parameter
     */
    findByTags(tags, excludeTags) {
        let r = this;

        // for each tag we are searching...
        tags.find(tag => {
            // ... create a new collection that contains only the models that
            // that match it.
            // jscs:disable

            r = new Taggable(
                //jscs:enable
                r.filter(model => {
                    return _.contains(model.get('tags'), tag);
                })
            );
            // if the collection is empty there is no point in continue
            // searching so we exit the find() loop early by returning `true`
            return (r.length === 0);
        });

        // if we need to exclude certain tags...
        if (excludeTags) {
            // we reset the models that already matched...
            r.reset(r.filter(model => {
                // and keep only the ones that don't have the given tag
                return !_.find(excludeTags, tag => {
                    return _.contains(model.get('tags'), tag);
                });
            }), {silent: true});
        }

        return r;
    }

    hasTag(tag) {
        return (this.findByTags([tag]).length > 0);
    }
};




// WEBPACK FOOTER //
// ./app/new-collections/mixins/taggable.js